import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { ShareOutlined } from '@material-ui/icons';
import { noop } from 'Helpers/PropTypes';

const styles = () => ({
  root: {
    aspectRatio: 1,
  },
});

const ShareButton = ({
  className,
  classes,
  onClick,
  ...rest
}) => {
  return (
    <IconButton
      className={classNames(classes.root, className)}
      icon={ShareOutlined}
      onClick={onClick}
      color="primaryGray"
      {...rest}
    />
  );
};

ShareButton.defaultProps = {
  className: '',
  onClick: noop,
};

ShareButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default withStyles(styles)(ShareButton);
